<div class="full-screen">
  @if (isRouteLoading) {
    <con-loader [showCircularLoder]="false"></con-loader>
  }
  <div class="header">
    <div class="header-left d-flex align-items-center justify-content-center">
      <div class="logo">
        <con-icon-by-name iconName="plug"></con-icon-by-name> connector
      </div>
    </div>
    <div class="header-right">
      <ul class="nav">
        <con-toolbar></con-toolbar>
        <li class="nav-item d-flex align-self-stretch ms-auto profile">
          <con-profile-handler class="d-flex"></con-profile-handler>
        </li>
      </ul>
    </div>
  </div>
  <div class="main">
    @if (!isInitialized) {
      <div class="w-100 text-center">
        <con-loader></con-loader>
      </div>
    } @else {
      <router-outlet></router-outlet>
    }
  </div>
  <div>
